import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { Button, Icons } from '../../../components/base/BootstrapComponents';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import SelectInput from '../../../components/fields/SelectInput/SelectInput';
import RadioButton from '../../../components/fields/RadioButton/RadioButton';
import { optionClassFormatter } from '../../../utils/formatters';
import CheckBoxInputWithLabel from '../../../components/fields/CheckBoxInput/CheckBoxInputWithLabel';
import FilterDTO from '../../../dto/FilterDTO';
import FieldWithAttributeDTO from '../../../components/fields/Abstract/FieldWithAttributeDTO';
import CameraDTO from '../../../dto/CameraDTO';
import { getCheckClassByName } from '../camera-utils';
import {
  CAMERA_STATUS, CAMERA_AVAILABLE_STATUS, deviceKeysT, processingKeysT,
} from '../constants';

export function FilterPresets(props) {
  const {
    keys = [],
    errorKeys = [],
    warningKeys = [],
    setValue,
    getValues,
    resetField,
  } = props;

  const isSelectOnly = (values = []) => values.every(e => getValues(e));

  const selectPreset = isError => () => {
    const keys = isError ? errorKeys : warningKeys;
    const isSelected = isSelectOnly(keys);
    const formData = getValues();

    for (let i = 0; i < keys.length; i++) {
      const current = keys[i];
      if (!isSelected) {
        setValue(current, !formData[current] ? keys.includes(current) : formData[current]);
      } else {
        resetField(current);
      }
    }
  };

  return (
    <div className="form-block-presets">
      <Button
        className={classNames('presets-button', { active: isSelectOnly(errorKeys, keys) })}
        variant="secondary"
        onClick={selectPreset(true)}
      >Ошибка
      </Button>
      <Button
        className={classNames('presets-button', { active: isSelectOnly(warningKeys, keys) })}
        variant="secondary"
        onClick={selectPreset(false)}
      >Некритическая поломка
      </Button>
    </div>
  );
}
export default function CamerasFilterForm(props) {
  const {
    onHide, resetField, meta, reset = () => {}, zones, register, getValues, setValue, defaultValues,
  } = props;
  const DTO = new CameraDTO();
  const filterDto = new FilterDTO();
  const attributes = DTO.getAttributesByName();
  const filterAttributes = filterDto.getAttributesByName();

  const availableStatusOptions = Object.values(CAMERA_AVAILABLE_STATUS).map(v => ({ value: Number(v), nameId: `cameras.available_status.${v}` })).reverse();
  const statusOptions = Object.values(CAMERA_STATUS).map(v => ({ value: Number(v), nameId: `cameras.status.${v}` })).reverse();
  const zonesOptions = zones.map(i => ({ name: i, value: i }));
  const [scroll, setScroll] = useState(null);
  useEffect(() => {
    const a = new window.IScroll('#filter-scroll-wrapper', {
      scrollbars: true,
      mouseWheel: true,
      preventDefault: false,
      interactiveScrollbars: true,
    });
    setScroll(a);
  }, []);
  useEffect(() => {
    if (scroll) {
      scroll.refresh();
    }
  }, [zones]);

  const clear = () => {
    reset(defaultValues);
  };

  const renderCheckBox = (name, index) => (
    <FieldWithAttributeDTO
      key={index}
      type="text"
      component={CheckBoxInputWithLabel}
      dtoObject={filterAttributes[name]}
      className={getCheckClassByName(name)}
      withLabel
      addPlaceholder
      inputProps={{
        value: getValues(name),
        ...register(name),
        onChange: () => setValue(name, !getValues(name)),
      }}
    />
  );

  return (
    <Dialog
      className={classNames('parking-meter-full-filter')}
      onClose={onHide}
      open
    >
      <DialogTitle
        className="pmff-title"
        title={(
          <>
            <div className="pmff-title-text f2">Фильтры</div>
            <div className="pmff-close-wrapper">
              <Icons width={14} height={14} customIcon icon="clear" className="pmff-close" onClick={onHide} />
            </div>
          </>
      )}
      />
      <DialogContent className="pff-content">
        <div className="scroll-wrapper filter-scroll-wrapper" id="filter-scroll-wrapper">
          <div className="scroll">
            <form>
              <FieldWithAttributeDTO
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.zbx_address}
                inputProps={{
                  value: getValues('address'),
                  ...register('address'),
                }}
              />
              <FieldWithAttributeDTO
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.host}
                className="mt-4"
                inputProps={{
                  value: getValues('host'),
                  ...register('host'),
                }}
              />
              <FieldWithAttributeDTO
                type="text"
                component={SelectInput}
                dtoObject={attributes.zbx_zone}
                className="mt-4"
                withLabel
                addPlaceholder
                options={zonesOptions}
                inputProps={{
                  value: getValues('zbx_zone'),
                  ...register('zbx_zone'),
                }}
              />
              <FieldWithAttributeDTO
                type="text"
                component={RadioButton}
                dtoObject={attributes.available_status}
                className="mt-4"
                withLabel
                addPlaceholder
                options={availableStatusOptions}
                optionClassFormatter={optionClassFormatter}
                inputProps={{
                  ...register('available_status'),
                  value: Number(getValues('available_status')),
                  onChange: e => {
                    setValue('available_status', Number(e.target.value));
                  },
                }}
              />
              <FieldWithAttributeDTO
                type="text"
                component={RadioButton}
                dtoObject={attributes.status}
                className="mt-4"
                withLabel
                addPlaceholder
                options={statusOptions}
                optionClassFormatter={optionClassFormatter}
                inputProps={{
                  ...register('status'),
                  value: Number(getValues('status')),
                  onChange: e => {
                    setValue('status', Number(e.target.value));
                  },
                }}
              />
              <div className="form-block-label filter-margin">
                <div className="form-block-label-text">Статус</div>
                <div
                  className="form-block-label-button"
                  onClick={() => reset({ ...getValues(), ...deviceKeysT })}
                >Сбросить
                </div>
              </div>
              <FilterPresets
                setValue={setValue}
                getValues={getValues}
                reset={reset}
                resetField={resetField}
                keys={Object.keys(deviceKeysT)}
                errorKeys={['DS_ERROR']}
                warningKeys={['DS_UNKNOWN',
                  'DS_NO_INIT_CAMERA',
                  'DS_NO_INIT_DETECTION',
                  'DS_NO_INIT_DETECT_VIOLATION']}
              />
              {Object.keys(deviceKeysT).map(renderCheckBox)}
              <div className="form-block-label filter-margin">
                <div className="form-block-label-text">Процессинг</div>
                <div
                  className="form-block-label-button"
                  onClick={() => reset({ ...getValues(), ...processingKeysT })}
                >Сбросить
                </div>
              </div>
              {Object.keys(processingKeysT).map(renderCheckBox)}
            </form>
          </div>
        </div>
      </DialogContent>
      <DialogFooter className="pmff-footer">
        <div className="pmff-footer-text">Нашли {meta && meta.total ? meta.total : 0} видеокамер</div>
        <div className="pmff-footer-buttons">
          <Button className="pmff-clear-data" variant="secondary" onClick={clear}>Сбросить</Button>
          <Button className="pmff-clear-show" onClick={onHide}>Показать</Button>
        </div>
      </DialogFooter>
    </Dialog>
  );
}
